function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Typography } from '@material-ui/core';
export function NoOptionsMessage(_ref) {
  var selectProps = _ref.selectProps,
      innerProps = _ref.innerProps;
  return /*#__PURE__*/React.createElement(Typography, _extends({
    color: "textSecondary",
    className: selectProps.childrenClasses.noOptionsMessage
  }, innerProps), selectProps.selectPromptMessage, "...");
}